import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { queryClient } from './api.ts';
// Before the router: the pages' own CSS must load after the shared rules.
import './styles.css';
import { router } from './router.tsx';

// queryClient lives in api.ts: its retry rule and the 401 → sign-in step sit next to the fetch code.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
